<template>
  <div class="channel_inventory_enquiry">
    <!--渠道库存查询头部-->
    <div class="channel_inventory_enquiry_top">
      <div class="first_line">
        <div>
          <el-select v-model.trim="selectChannelValue" placeholder="请选择">
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="wper13">
          <el-select v-model.trim="selectBrandType" placeholder="请选择">
            <el-option
              v-for="item in brandTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div><input type="text" v-model.trim="numOrName" title="货号/品名" placeholder="货号/品名"></div>
        <div class="wper8"><input type="text" v-model.trim="color" title="颜色" placeholder="颜色"></div>
        <div class="wper8"><input type="text" v-model.trim="size" title="尺码" placeholder="尺码"></div>
        <div class="w32">库存:</div>
        <div class="w70">
          <el-select v-model.trim="selectSymbolType" placeholder="请选择">
            <el-option
              v-for="item in symbolType"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="wper9"><input type="text" v-model.trim="inventory" @keyup="floatNum()" title="库存数值"></div>
        <button class="btn_normal w116 fr" @click="queryData()">查询</button>
      </div>
      <div class="second_line text_right">
        <button class="btn_normal w116" @click="ctrBtn('exportInventory')">导出库存</button>
      </div>
    </div>
    <!--渠道库存查询信息-->
    <div class="channel_inventory_enquiry_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>渠道</th>
          <th>品牌</th>
          <th>货号</th>
          <th>品名</th>
          <th>颜色</th>
          <th>尺码</th>
          <th>库存</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <!--<td>{{item.SupplierCode}}_{{item.StoreroomName}}</td>-->
          <td>{{item.StoreroomName}}</td>
          <td>{{item.BrandName}}</td>
          <td>{{item.GoodsId}}</td>
          <td>{{item.GoodsName}}</td>
          <td>{{item.ColorAlias}}</td>
          <td>{{item.Size}}</td>
          <td>{{item.XStock}}</td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="7">暂时没有相关的信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!--弹出框-->
    <channel-inventory-enquiry-embed-msg v-if="isShow"
                                         :title="dialogTitle"
                                         :params="params"
                                         :exportInventoryMsg="exportInventoryMsg"
                                         :showType="dialogShowType"
                                         @cancelbtn="getSelectDialogEmbed"></channel-inventory-enquiry-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import ChannelInventoryEnquiryEmbedMsg from './channel-inventory-enquiry-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'channel-inventory-enquiry',
    components: {ChannelInventoryEnquiryEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        list: '', // 渠道库存列表
        selectChannelValue: '', // 选择的渠道列表
        channelList: [
          {id: '', text: '所有渠道'}
        ], // 渠道下拉列表
        selectBrandType: '', // 选择到的查询品牌类型
        brandTypeList: [
          {id: '', text: '所有品牌'}
        ], // 查询品牌下拉列表
        numOrName: '', // 货号/品名
        color: '', // 颜色
        size: '', // 尺码
        selectSymbolType: 0, // 选择的符号
        symbolType: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 符号类型下拉列表
        inventory: null, // 库存
        params: null, // 导出的传入参数
        exportInventoryMsg: '', // 导出的成本价信息
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 根据渠道 + 品牌 + 货号/品名 + 颜色 + 尺码 + 符号 + 库存 查询
      queryData() {
        this.currentPage = 1;
        this.loadAllStoreroomStockPageData();
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 获取品牌下拉框信息
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 渠道库存查询分页数据
      loadAllStoreroomStockPageData() {
        this.isLoading = true;
        this.list = [];
        this.params = {
          goodsIdOrName: this.numOrName,
          storeroomId: this.selectChannelValue,
          xStock: parseFloat(this.inventory),
          brandId: this.selectBrandType,
          colorAlias: this.color,
          sizeName: this.size,
          symbol: this.selectSymbolType,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAllStoreroomStockPageData, this.params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res.data) {
              clearTimeout(timer);
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 验证正浮点数字
      floatNum() {
        if (this.inventory === '0') {
          this.inventory = 0;
        } else if (parseFloat(this.inventory)) {
          this.inventory = parseFloat(this.inventory);
        } else {
          this.inventory = null;
        }
      },

      // 操作按钮
      ctrBtn(type) {
        this.isShow = true;
        this.dialogShowType = type;
        this.dialogTitle = '提示';

        // 传入参数的判断
        let selectChannelValue, selectBrandType, selectSymbolType;
        if (this.selectChannelValue === '所有渠道') {
          selectChannelValue = '';
        } else {
          selectChannelValue = this.selectChannelValue;
        }
        if (this.selectBrandType === '所有品牌') {
          selectBrandType = '';
        } else {
          selectBrandType = this.selectBrandType;
        }
        if (this.selectSymbolType === '符号') {
          selectSymbolType = 0;
        } else {
          selectSymbolType = this.selectSymbolType;
        }
        this.params = {
          idOrName: this.numOrName,
          storeroomId: selectChannelValue,
          xStock: parseFloat(this.inventory),
          brandId: selectBrandType,
          colorAlias: this.color,
          sizeName: this.size,
          symbol: selectSymbolType,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllStoreroomStockPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllStoreroomStockPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getAllStoreroomsList();
      this.getAllBrandsList();
      this.loadAllStoreroomStockPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.selectChannelValue = '';
        this.selectBrandType = '';
        this.numOrName = '';
        this.color = '';
        this.size = '';
        this.selectSymbolType = 0;
        this.inventory = '';
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadAllStoreroomStockPageData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .channel_inventory_enquiry {
    .channel_inventory_enquiry_top {
      padding: 20px 5px 5px;

      .first_line, .second_line {
        height: 45px;
        line-height: 40px;

        &>div {
          display: inline-block;
          width: 15%;
          margin-right: 0.5%;
        }

        .wper8 {
          width: 8%;
        }

        .wper9 {
          width: 9%;
        }

        .wper13 {
          width: 13%;
        }

        .w32 {
          width: 32px;
        }

        .w70 {
          width: 70px;
        }
      }
    }

    .channel_inventory_enquiry_msg {
      height: calc(100% - 115px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/channel-inventory-enquiry.vue